/* 1-nov-2026: packs de Millo Coins solo para miembros activos. Bolsos y ropa se compran sin Coins ni nivel.
   El cajón y /cart muestran el aviso para packs. Antes de salir al pago se relee la bolsa; los cambios de membresía
   confirmados por el estado firmado del club actualizan este control. La validación de premios queda en el servidor. */
(function(){
  var G = window.MG_GATE; if(!G) return;
  if(window.MG_COINS_POLICY && window.MG_COINS_POLICY.simulated){G.in=window.MG_COINS_POLICY.active;G.coins=G.in?1:0;}
  var max = 0; for(var h in G.umbral) if(G.umbral[h] > max) max = G.umbral[h];


  var T = G.t;
  var LOCK = '<svg width="11" height="12" viewBox="0 0 14 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="1" y="7" width="12" height="8"/><path d="M4 7V4.5a3 3 0 0 1 6 0V7"/></svg>';
  function esc(t){ return String(t).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function fmt(n){ return String(Math.max(0, Math.round(n))).replace(/\B(?=(\d{3})+(?!\d))/g, G.en ? ',' : '.'); }
  function falta(h){ var u = G.umbral[h] || 0; return u > 0 && (!G.in || G.coins < u) ? u - Math.max(0, G.coins) : 0; }
  function handleOf(row){
    var a = row.querySelector('a[href*="/products/"]'), m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* una pasada sobre la bolsa (cajón o página): idempotente, solo toca lo que cambia */
  function apply(root, page){
    var rows = [].slice.call(root.querySelectorAll(page ? '.it' : '.items .it')), locked = [], f = 0;
    rows.forEach(function(row){
      var fh = falta(handleOf(row)), note = row.querySelector('.mgcg-note');
      if(fh){
        locked.push(row); if(fh > f) f = fh;
        var txt = G.in ? T.n_lv.replace('[f]', fmt(fh)) : T.n_in;
        if(!note || note.textContent !== txt){
          if(note) note.remove();
          var info = row.children[1], sm = info && info.querySelector('.sm');
          if(info){ var p = document.createElement('p'); p.className = 'mgcg-note'; p.innerHTML = LOCK + '<span>' + esc(txt) + '</span>';
            if(sm) sm.insertAdjacentElement('afterend', p); else info.appendChild(p); }
        }
      } else if(note) note.remove();
    });
    var foot = page ? root.querySelector('.btns') : root.querySelector('.bf'), box = root.querySelector('.mgcg-box');
    var pays = [].slice.call(root.querySelectorAll(page ? 'button[name="checkout"]' : '.bf a[href*="/checkout"]'));
    pays.forEach(function(b){ b.setAttribute('data-mgcg-pay', ''); if(!!b.hidden !== !!locked.length) b.hidden = !!locked.length; });
    if(!locked.length){ if(box) box.remove(); if(G.removing) G.removing = 0; return; }
    var otros = rows.length > locked.length, sig = (G.in ? 'lv' + f : 'in') + '-' + (otros ? 1 : 0), x = otros ? T.x2 : T.x;
    if(!box || box.getAttribute('data-sig') !== sig){
      if(box) box.remove();
      box = document.createElement('div'); box.className = 'mgcg-box'; box.setAttribute('aria-live', 'polite'); box.setAttribute('data-sig', sig);
      box.innerHTML = G.in
        ? '<p class="mgcg-h">' + esc(T.h_lv) + '</p><p class="mgcg-p">' + esc(T.p_lv.replace('[f]', fmt(f))) + '</p><button type="button" class="btn" data-mgcg-remove>' + esc(x) + '</button>'
        : '<p class="mgcg-h">' + esc(T.h_in) + '</p><p class="mgcg-p">' + esc(T.p_in) + '</p><a class="btn" href="' + esc(G.login) + '">' + esc(T.b_in) + '</a><button type="button" class="mgcg-x" data-mgcg-remove>' + esc(x) + '</button>';
      if(page && foot) foot.parentNode.insertBefore(box, foot);
      else if(pays[0]) pays[0].parentNode.insertBefore(box, pays[0]);
      else if(foot) foot.appendChild(box);
    }
    /* «Quitar los Millo Coins» en el cajón: se quita fila a fila con su propio botón (mg-theme.js vuelve a pintar la bolsa) */
    if(G.removing && !page && G.removing < 6){ var rm = locked[0].querySelector('.rm'); if(rm){ G.removing++; setTimeout(function(){ rm.click(); }, 0); } }
  }

  var bag = document.querySelector('.bag'), cartp = document.querySelector('.cartp');
  if(bag){
    var queued = false;
    var run = function(){ queued = false; apply(bag, false); };
    /* setTimeout y no requestAnimationFrame: este no corre con la pestaña en segundo plano y la bolsa quedaría sin marcar */
    new MutationObserver(function(){ if(!queued){ queued = true; setTimeout(run, 0); } }).observe(bag, { childList: true, subtree: true });
    run();
  }
  if(cartp) apply(cartp, true);
  document.addEventListener('millo:estado', function(e){
    var state=e.detail || {};
    if(typeof state.miembro_activo !== 'boolean')return;
    G.in=state.miembro_activo;G.coins=G.in?1:0;
    if(bag)apply(bag,false);if(cartp)apply(cartp,true);
  });

  /* quitar los packs restringidos */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-mgcg-remove]'); if(!b) return;
    e.preventDefault();
    if(b.closest('.bag')){ G.removing = 1; apply(bag, false); return; }
    var up = {};
    [].slice.call(document.querySelectorAll('.cartp .it[data-key]')).forEach(function(row){ if(falta(handleOf(row))) up[row.getAttribute('data-key')] = 0; });
    if(!Object.keys(up).length){ if(b.href) location.href = b.href; return; }
    b.setAttribute('aria-disabled', 'true');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up }) })
      .then(function(){ location.reload(); }, function(){ if(b.href) location.href = b.href; });
  });

  /* red de seguridad: cualquier enlace o botón de pago del tema mira la bolsa real antes de salir hacia el pago */
  function isPay(u){ try{ var p = new URL(u, location.href).pathname; return /\/checkouts?(\/|$)/.test(p) || /\/cart\/\d+:\d+/.test(p); }catch(x){ return false; } }
  function guard(e, go){
    e.preventDefault(); e.stopImmediatePropagation();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      var malos = (c.items || []).filter(function(it){ return falta(it.handle); });
      if(!malos.length) return go();
      if(cartp){ apply(cartp, true); var bx = cartp.querySelector('.mgcg-box'); if(bx) bx.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      else location.href = (window.MG && MG.routes && MG.routes.cart) || '/cart';
    }, function(){ location.href = (window.MG && MG.routes && MG.routes.cart) || '/cart'; });
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href]');
    if(a && !a.hasAttribute('data-mgcg-remove') && isPay(a.getAttribute('href'))) guard(e, function(){ location.href = a.href; });
  }, true);
  document.addEventListener('submit', function(e){
    var f = e.target, sb = e.submitter;
    if(!(sb && sb.name === 'checkout') && !isPay(f.getAttribute('action') || '')) return;
    guard(e, function(){
      if(sb && sb.name === 'checkout'){ var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = sb.value || '1'; f.appendChild(i); }
      HTMLFormElement.prototype.submit.call(f);
    });
  }, true);
})();
